import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { useSnackbar } from "notistack";

import { Grid, Chip, Typography } from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@material-ui/icons/Close";
import {
  sendInviteManagerApiCall,
  submitManagerApiCall,
  submitIPAddressApiCall,
} from "../../actions/Operations";
import {
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
} from "../../Redux/Actions/merchantInformation";

import { profileCodePermissionCheck } from "../../Utils/commonUtils";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    borderRadius: 8,
    maxWidth: 600,
    width: "90%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
}));

const WhitelistedApiModal = ({
  onClose,
  props,
  rows,
  Bussines_id,
  rowForEdit,

  handleRefresh,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [firstName, setFirstName] = useState("");
  const menu = JSON.parse(localStorage.getItem("menu"));

  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [phoneNumber, setPhone] = useState("");

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [businessName, setBusinessName] = useState(null);
  const [businessType, setBusinessType] = useState("");
  const selectedBusiness = null;
  const selectedGroupVisibility = null;

  // State variables for form inputs and modal behavior
  const [platformType, setPlatformType] = useState();
  const [buttonFlag, setButtonFlag] = useState(false);
  const [errorIp, setErrorIp] = useState(false);
  const [textArea, setTextArea] = useState(false);

  const dispatch = useDispatch();

  const profileCode = menu?.Role_Permission_Data?.Profile_Code;
  const accountAccessibility = [];
  const Manager_uid_Storage = localStorage.getItem("Merchant_uid");
  const Manager_uid = Manager_uid_Storage ? JSON.parse(localStorage.getItem("Manager_uid")) : "";
  const User_Id = localStorage.getItem("User_Id");
  const businessNameData = localStorage.getItem("businessName");
  const [ipAddresses, setIpAddresses] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Effect to populate IP addresses from rowForEdit
  React.useEffect(() => {
    if (rowForEdit) {
      const setIpAddressesValueHandle = () => {
        if (rowForEdit?.Allowed_IP) {
          rowForEdit.Allowed_IP.forEach((item) => {
            setIpAddresses((prev) => [...prev, item.IP]);
          });
        }
      };

      setIpAddressesValueHandle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);

  React.useEffect(() => {
    if (businessNameData) {
      setBusinessName(
        <Select
          labelId="business-name"
          id="business-name"
          disabled
          value={businessNameData}
          required
        >
          {rows.map((row) => (
            <MenuItem value={`${row.Business_Name}`}>
              {row.Business_Name}
            </MenuItem>
          ))}
        </Select>
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Bussines_id, businessNameData]);

  React.useEffect(() => {
    if (rowForEdit.User_Merchant_AcctLinks_Details) {
      // Extract Group_Visibility array and set it to selectedRows
      const userMerchantAcctLinksDetails =
        rowForEdit?.User_Merchant_AcctLinks_Details || [];
      setSelectedRows(userMerchantAcctLinksDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const onFormSendInvite = () => {
    if (!firstName || !lastName || !email || !phoneNumber || !businessName) {
      enqueueSnackbar("Please fill out all required fields.", {
        variant: "error",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar("Please enter a valid email address.", {
        variant: "error",
      });
      return;
    }
    const startsWithNumberRegex = /^\d/;
    if (
      startsWithNumberRegex.test(firstName) ||
      startsWithNumberRegex.test(lastName)
    ) {
      enqueueSnackbar("First/Last name cannot start with a number.", {
        variant: "error",
      });
      return;
    }

    const businessId =
      Bussines_id == null ? selectedBusiness?._id : Bussines_id;
    props.sendInviteManagerApiCall(
      {
        firstName: firstName.charAt(0).toUpperCase() + firstName.slice(1),
        lastName: lastName.charAt(0).toUpperCase() + lastName.slice(1),
        email: email.toLowerCase(),
        phoneNumber,
        businessName,
        Status_Code: 1,
        accountAccessibility,
        Group_Visibility: selectedGroupVisibility,
        Platform_Accessibility: platformType,
        groupCodes: selectedRows,
        Bussines_id: businessId,
        Profile_id: Manager_uid,
        User_Id,
        Type: `${profileCode === profileCodePermissionCheck.profileCode.VCS
            ? businessType
            : "sub"
          }`,
      },
      (res) => {
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, {
            variant: "success",
          });
          onClose();
          handleRefresh();

          // props.history.push(
          //   `/${props.mainData.app.layout}/ManagerList${props.location.search}`
          // );
          // window.location.reload();
        }
      },
      (error) => {
        enqueueSnackbar(`${error.message}`, {
          variant: "error",
        });
      }
    );
  };

  React.useEffect(() => {
    if (rowForEdit.Business_Name) {
      setBusinessName(rowForEdit?.Business_Name);
      setButtonFlag(true);
      setPlatformType(rowForEdit.Platform_Accessibility);
      setBusinessType(rowForEdit.Type);
    } else {
      setButtonFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailListData?.data && email) {
      const emailExists =
        props.merchantListData.emailListData.data.includes(email);
      if (emailExists) {
        dispatch(getEmailData(email));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailListData?.data, email]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailData) {
      const { First_Name, Last_Name, Phone_Number } =
        props?.merchantListData?.emailData;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailData]);
  React.useEffect(() => {
    if (rowForEdit) {
      const {
        Email, First_Name, Last_Name, Phone_Number,
      } = rowForEdit;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
      setEmail(Email || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);

  React.useEffect(
    () => () => {
      dispatch(emptyEmailListReduxState());
    },
    [dispatch]
  );

  // Function to validate IP addresses
  const isValidIP = (ip) => {
    const ipv4Regex =
      /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/;

    const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)$/;

    return ipv4Regex.test(ip) || ipv6Regex.test(ip);
  };

  // Function to handle adding an IP address
  const handleAddIP = () => {
    if (inputValue.trim() === "") return;
    if (!isValidIP(inputValue)) {
      setErrorIp("Invalid IP Address");
      return;
    }
    if (!ipAddresses.includes(inputValue)) {
      setIpAddresses([...ipAddresses, inputValue]);
      setInputValue("");
      setErrorIp(null);
      setTextArea(false);
    } else {
      setErrorIp("IP Address already added");
    }
  };
  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission

      if (inputValue.trim() !== "") {
        handleAddIP(); // Add IP if input is not empty
      } else {
        handleSubmit(); // If empty, trigger submit
      }
    }
  };

  // Handle input field blur (when user clicks outside)
  const handleBlur = () => {
    if (inputValue.trim() !== "") {
      handleAddIP();
    } else {
      handleSubmit();
    }
  };
  // Handle Submit Button Click
  const handleSubmit = () => {
    if (ipAddresses.length === 0) {
      setErrorIp("No IP addresses added!");
    }
  };

  // Function to handle form submission
  const onFormSubmit = () => {
    // Ensure ipAddresses is an array of objects, not strings
    const formattedIPAddresses = ipAddresses?.map((ip) =>
      typeof ip === "string"
        ? {
          IP: ip,
          Created_Date: new Date().toISOString(),
          Created_By: rowForEdit?.Created_By,
          Updated_Date: rowForEdit?.Updated_date,
          Updated_By: rowForEdit?.full_name,
        }
        : ip);

    const payload = {
      Business_ID: rowForEdit?.Bussines_id,
      Manager_ID: rowForEdit?.Manager_ID,
      Allowed_IP: formattedIPAddresses,
    };
    props.submitIPAddressApiCall(
      payload,
      (res) => {
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, { variant: "success" });
          onClose();
          handleRefresh();
        }
      },
      (error) => {
        enqueueSnackbar(`${error.message}`, { variant: "error" });
      }
    );
  };

  // Function to handle deleting an IP address
  const handleDeleteChip = (ip) => {
    setIpAddresses(ipAddresses.filter((item) => item !== ip));
  };

  const handleTextArea = () => {
    setTextArea(true);
  };

  return (
    <>
      <Modal open onClose={onClose}>
        <div className={classes.paper}>
          <h2>Whitelisted IP Addresses</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className={classes.inputContainer}>
              <Grid container spacing={2}>
                <Grid
                  style={{
                    textAlign: "start",
                  }}
                  item
                  lg={3}
                  sm={3}
                  xs={3}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingRight: "0px",
                    }}
                  >
                    Business Name
                  </div>
                </Grid>
                <Grid
                  style={{
                    textAlign: "start",
                    paddingLeft: "0px",
                  }}
                  item
                  lg={6}
                  sm={6}
                  xs={6}
                >
                  :&nbsp;&nbsp;
                  {businessName}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  style={{
                    textAlign: "start",
                  }}
                  item
                  lg={3}
                  sm={3}
                  xs={3}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingRight: "0px",
                    }}
                  >
                    Email
                  </div>
                </Grid>
                <Grid
                  style={{
                    textAlign: "start",
                    paddingLeft: "0px",
                  }}
                  item
                  lg={6}
                  sm={6}
                  xs={6}
                >
                  :&nbsp;&nbsp;
                  {email}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  style={{
                    textAlign: "start",
                  }}
                  item
                  lg={3}
                  sm={3}
                  xs={3}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingRight: "0px",
                    }}
                  >
                    Platform
                  </div>
                </Grid>
                <Grid
                  style={{
                    textAlign: "start",
                    paddingLeft: "0px",
                  }}
                  item
                  lg={6}
                  sm={6}
                  xs={6}
                >
                  :&nbsp;&nbsp;
                  {platformType || rowForEdit?.Platform_Accessibility}
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <div style={{ display: "ruby", width: "100%" }}>
                  {ipAddresses?.map((ip, index) => (
                    <Grid
                      style={{ paddingBottom: "10px" }}
                      item
                      key={index}
                      lg={6}
                      sm={6}
                      xs={6}
                    >
                      <Chip
                        label={ip}
                        onDelete={() => handleDeleteChip(ip)}
                        deleteIcon={<CloseIcon />}
                      />
                    </Grid>
                  ))}
                </div>
                {!textArea && (
                  <Grid item lg={12} sm={12} xs={12}>
                    <AddCircleOutlineIcon
                      style={{ cursor: "pointer", fontSize: "175%" }}
                      onClick={() => handleTextArea()}
                    />
                  </Grid>
                )}
                {textArea && (
                  <Grid item lg={12} sm={12} xs={12}>
                    <TextField
                      label="IP Addresses"
                      variant="outlined"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={handleBlur} // Trigger when clicking outside
                      required
                      fullWidth
                      InputProps={{
                        inputProps: {
                          style: { textTransform: "capitalize" },
                        },
                      }}
                    //    disabled={
                    //      buttonFlag == true
                    //        ? true
                    //        : profileCode ===
                    //          profileCodePermissionCheck.profileCode.VCS
                    //        ? !businessType
                    //        : !businessName
                    //    }
                    />
                    <Typography
                      style={{
                        display: "flex",
                        marginTop: "4px",
                        color: "red",
                      }}
                    >
                      {errorIp}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </div>
            {buttonFlag === true ? (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={ipAddresses.length === 0}
                className={classes.button}
                onClick={onFormSubmit}
              >
                Submit
                {" "}
              </Button>
            ) : (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onFormSendInvite}
              >
                Send Invite
              </Button>
            )}
          </form>
        </div>
      </Modal>
    </>
  );
};

// Prop types for the WhitelistedApiModal component
WhitelistedApiModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  sendInviteManagerApiCall: PropTypes.func,
  submitManagerApiCall: PropTypes.func,
  getManagerListDataNames: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getEmailList: PropTypes.func,
  submitIPAddressApiCall: PropTypes.func,
  getEmailData: PropTypes.func,
  emptyEmailListReduxState: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  mainData: app,
  roles: app.roles,
  app: app.app,
  signUpData: app,
  merchantListData: app.merchantInformation,
  managerListData: app.merchantInformation,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  sendInviteManagerApiCall,
  submitIPAddressApiCall,
  submitManagerApiCall,
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
})(WhitelistedApiModal);
